const County = `
  id
  code
  countryId
  description
`;

export default County;
